import React from "react";
import {Dialog, DialogContent, DialogTitle} from "../../components/nuclear/dialog";
import "./PolicyModal.module.css";

export function PolicyModal({isOpen, onClose, title, contentHtml}) {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => {
            if (!open) {
                onClose();
            }
        }}>
            <DialogContent className={"auth-modal-content"}>
                <div className={"auth-modal-header"}>
                    <DialogTitle className={"auth-modal-title"}>{title}</DialogTitle>
                </div>
                <iframe
                    srcDoc={contentHtml}
                    title={title}
                    className={"auth-modal-iframe"}
                />
            </DialogContent>
        </Dialog>
    );
}
